import validator from "validator";

// Password regex
// const passwordRegex = new RegExp(
//   "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})"
// );
const patternPwd =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/;

export const loginValidation = (data) => {
  let errors = {};
 

  if (validator.isEmpty(data?.username.trim()))
    errors.username = "Please enter username";

  if (validator.isEmpty(data?.password.trim()))
    errors.password = "Please enter password";

  // if (data?.email && !validator.isEmail(data.email))
  //   errors.email = "Email address must be valid";

  // if (validator.isEmpty(data?.password.trim()))
  //   errors.password = "Please enter password";
  // else if (!patternPwd.test(data?.password))
  //   errors.password =
  //     "Password should be at least 8 characters with upper case, number and special character";

  return { errors, isValid: Object.keys(errors).length <= 0 };
};

export const loginValidationMobile = (data) => {
  let errors = {};
  if (validator.isEmpty(data?.contact.trim()))
    errors.contact = "Please enter mobile number";


  return { errors, isValid: Object.keys(errors).length <= 0 };
};

export const signupValidation = (data) => {
  let errors = {};
  console.log(data);

  if (validator.isEmpty(data?.name.trim())) {
    errors.name = "Please enter name";
  }

  if (validator.isEmpty(data?.username.trim())) {
    errors.username = "Please enter username";
  }

  // Optional agentCode: validate only if entered
  const agentCodeTrimmed = data?.agentCode?.trim();
  if (agentCodeTrimmed && agentCodeTrimmed.length !== 7) {
    errors.agentCode = "Agent code must be exactly 7 characters";
  }
  
  if (!data?.birthDate) {
    errors.birthDate = "Please enter date of birth";
  }

  if (validator.isEmpty(data?.contact?.trim())) {
    errors.contact = "Please enter mobile number";
  }

  if (!data.adult) {
    errors.adult = "Please select";
  }

  return { errors, isValid: Object.keys(errors).length <= 0 };
};

// export const signupValidation = (data) => {
//   let errors = {};
//   console.log(data)

//   if (validator.isEmpty(data?.name.trim())) errors.name = "Please enter name";
//   if (validator.isEmpty(data?.username.trim()))
//     errors.username = "Please enter username";

//   if (validator.isEmpty(data?.agentCode.trim())) errors.agentCode = "Please enter agent code";

//   if (!(data?.birthDate))
//     errors.birthDate = "Please enter date of birth";
//   //mobile

//   if (validator.isEmpty(data?.contact.trim())) errors.contact = "Please enter mobile number";

//   if(!data.adult) {
//     errors.adult = "Please select"
//   }

//   // if (data?.email && !validator.isEmail(data.email))
//   //   errors.email = "Email address must be valid";

//   // if (validator.isEmpty(data?.email.trim()))
//   //   errors.email = "Please enter email address / phone number";

//   // const isValidPhoneNumber = validator.isMobilePhone(data.mobile);
//   // console.log({isValidPhoneNumber})

//   return { errors, isValid: Object.keys(errors).length <= 0 };
// };
export const signupPwdValidation = (data) => {
  let errors = {};

  if (validator.isEmpty(data?.password1.trim()))
    errors.password1 = "Please enter password";
  else if (!patternPwd.test(data?.password1))
    errors.password1 =
      "Password should be at least 8 characters with upper case, number and special character";

  if (data?.password1 !== data?.password2) {
    errors.password2 = "Both password should be same.";
  }

  return { errors, isValid: Object.keys(errors).length <= 0 };
};

export const forgotPasswordValidation = (data) => {
  let errors = {};

  if (validator.isEmpty(data?.oldPassword.trim()))
    errors.oldPassword = "Please enter password";
  else if (!patternPwd.test(data?.oldPassword))
    errors.oldPassword =
      "Old Password should be at least 8 characters with upper case, number and special character";

  if (validator.isEmpty(data?.newPassword.trim()))
    errors.newPassword = "Please enter password";
  else if (!patternPwd.test(data?.newPassword))
    errors.newPassword =
      "New Password should be at least 8 characters with upper case, number and special character";

  if (data.oldPassword === data.newPassword) {
    errors.newPassword = "Old Password and New Password should not be same.";
  }

  return { errors, isValid: Object.keys(errors).length <= 0 };
};

export const resetPasswordValidation = (data) => {
  let errors = {};
  if (validator.isEmpty(data?.password?.trim()))
    errors.password = "Please enter new password";

  if (!validator.isEmpty(data?.password?.trim()) && data?.password?.length < 6)
    errors.password = "Password must be at least 6 characters";

  return { errors, isValid: Object.keys(errors).length <= 0 };
};
